import styled from 'styled-components';

import { spin } from './animations';

export const Container = styled.div`
  position: relative;
  text-indent: -9999em;
  border-top: 2px solid rgba(0, 0, 0, 0.26);
  border-right: 2px solid rgba(0, 0, 0, 0.26);
  border-bottom: 2px solid rgba(0, 0, 0, 0.26);
  border-left: 2px solid transparent;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: ${spin} 0.8s infinite linear;
  animation: ${spin} 0.8s infinite linear;

  &,
  &:after {
    border-radius: 50%;
    width: 22px;
    height: 22px;
  }
`;
